/**
 * @generated SignedSource<<b85853fa93d70e57e6d88e584bb60200>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type OpsgenieIntegrationDeleteIntegrationMutation$variables = {
  input: DeleteIntegrationInput;
};
export type OpsgenieIntegrationDeleteIntegrationMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type OpsgenieIntegrationDeleteIntegrationMutation = {
  response: OpsgenieIntegrationDeleteIntegrationMutation$data;
  variables: OpsgenieIntegrationDeleteIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsgenieIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsgenieIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa781a3247966500ccbf9c6ad7d3486c",
    "id": null,
    "metadata": {},
    "name": "OpsgenieIntegrationDeleteIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation OpsgenieIntegrationDeleteIntegrationMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8360cfd90bc8e5f6ec157e8bd8f9a8e";

export default node;
